import { render, staticRenderFns } from "./PlanoCama.vue?vue&type=template&id=529d0434&"
import script from "./PlanoCama.vue?vue&type=script&lang=js&"
export * from "./PlanoCama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports